import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';
import iconCustomer from "src/assets/images/admin-dashboard/customer-icon.png";
import iconDoctor from "src/assets/images/admin-dashboard/doctor-icon.png";
import { CircularProgress } from '@mui/material';
import SelectDropdown from 'src/Components/GlobalComponents/SelectDropdown';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { cityList } from 'src/Config/CityList';
import { IDropDownArray } from 'src/types/GlobalInterfaces';
import { allMonths, CURRENCY } from 'src/lib/constans';
import iconRevenue from "src/assets/images/admin-dashboard/revenue-icon.png";

const timePeriodOptions: IDropDownArray[] = [{ label: "Monthly", value: "monthly" }, { label: "Yearly", value: "yearly" }];
interface IResponse {
    yearlyData: { count: number; year: number; }[];
    yearlyTotal: { totalYearlyData: number; }[];
    monthlyData: { count: number; month: number; year: number }[];
    monthlyTotal: { totalMonthlyData: number; }[];
};

const UserOverview: React.FC = () => {
    const [userData, setUserData] = useState<any>({
        loader: false,
        totalCustomers: 0,
        totalDoctors: 0,
        pendingWithdrawal:0,
    });
    const [data,setData]=useState<any>({})
    const fetchTotalCount = async () => {
        setUserData((prev:any) => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<any>({ path: "/customer/total" });
        if (res) {
            setUserData((prev:any) => ({
                ...prev,
                totalCustomers: res?.[0]?.totalCustomers,
                totalDoctors: res?.[0]?.totalDoctors,
                pendingWithdrawal: res?.[0]?.pendingWithDrawCount
            }));
        } else {
            toast(err, { type: "error" });
        }
        setUserData((prev:any) => ({ ...prev, loader: false }));
    };
    useEffect(() => {
        fetchTotalCount();
    }, []);

    const [customerStates, setCustomerStates] = useState<{ loader: boolean; city: string; timePeriod: "monthly" | "yearly"; data: IResponse | null }>({
        loader: false,
        city: "",
        timePeriod: "monthly",
        data: null,
    });

    const customerFormatedData = (): any => {
        const year = new Date()?.getFullYear();
        if (customerStates?.timePeriod === "monthly") {
            // const _data = customerStates?.data?.monthlyData?.filter(v => v?.year === year)?.map(v => ({ count: v?.count, name: allMonths?.find(mon => mon?.month === v?.month)?.name }))?.sort((a,b)=>a.month-b.month);
            const _data = customerStates?.data?.monthlyData
                ?.filter(v => v?.year === year)
                ?.map(v => ({
                    count: v.count,
                    name: allMonths?.find(mon => mon?.month === v?.month)?.name,
                    month: v.month,
                }))
                ?.sort((a, b) => a.month - b.month);
            return _data || [];
        } else {
            const _data = customerStates?.data?.yearlyData?.map(v => ({ count: v?.count, name: v?.year }))?.sort((a, b) => a.name - b.name);
            return _data || [];
        }
    };
    const fetchCustomerRecord = async () => {
        setCustomerStates(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<IResponse[]>({ path: `/customer/statistics?search=${customerStates?.city}` });
        if (res) {
            setCustomerStates(prev => ({ ...prev, data: res?.[0] || null }))
        } else {
            toast(err, { type: "error" });
        }
        setCustomerStates(prev => ({ ...prev, loader: false }));
    };
    useEffect(() => {
        fetchCustomerRecord();
    }, [customerStates?.city]);

    const [doctorStates, setDoctorStates] = useState<{ loader: boolean; city: string; timePeriod: "monthly" | "yearly"; data: IResponse | null }>({
        loader: false,
        city: "",
        timePeriod: "monthly",
        data: null,
    });

    const doctorFormatedData = (): any => {
        const year = new Date()?.getFullYear();
        if (doctorStates?.timePeriod === "monthly") {
            const _data = doctorStates?.data?.monthlyData?.filter(v => v?.year === year)?.map(v => ({ count: v?.count, name: allMonths?.find(mon => mon?.month === v?.month)?.name }));
            return _data || [];
        } else {
            const _data = doctorStates?.data?.yearlyData?.map(v => ({ count: v?.count, name: v?.year }))?.sort((a, b) => a.name - b.name);
            return _data || [];
        }
    };
    const fetchDoctorRecord = async () => {
        setDoctorStates(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<IResponse[]>({ path: `/doctors/statistics?search=${doctorStates?.city}` });
        if (res) {
            setDoctorStates(prev => ({ ...prev, data: res?.[0] || null }))
        } else {
            toast(err, { type: "error" });
        }
        setDoctorStates(prev => ({ ...prev, loader: false }));
    };

    const [isLoader, setIsLoader] = useState<boolean>(false);

    const fetchRevenuedStats = async () => {
        setIsLoader(true);
        const { res, err } = await httpRequest<any>({ path: "/pharma-order/admin/statistics/revenue-monthly" });
        if (res) {
           setData(res?.data)
        } else {
            toast(err, { type: 'error' });
        }
        setIsLoader(false);
    };


    useEffect(() => {
        fetchDoctorRecord();
        fetchRevenuedStats()
    }, [doctorStates?.city]);

    return (
        <div className='gap-marging-admin'>
            <div className='parent-box'>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
                    <div className="dashboard-sm-box">
                        <div className="dashboard-inner-box w-[80%] text-center">
                            <img className='admin-dashboard-img' src={iconCustomer} alt="biomarker-icon" />
                            <p className="font-Poppins-Medium whitespace-nowrap font-size-20px">Total Customers</p>
                            {userData?.loader
                                ?
                                <CircularProgress size={20} className="theme-color-green" />
                                :
                                <p className="font-Poppins-SemiBold font-size-24px theme-color-green">
                                    {userData?.totalCustomers || "-"}
                                </p>
                            }
                        </div>
                    </div>
                    <div className="dashboard-sm-box">
                        <div className="dashboard-inner-box w-[80%] text-center">
                            <img className='admin-dashboard-img' src={iconDoctor} alt="biomarker-icon" />
                            <p className="font-Poppins-Medium whitespace-nowrap font-size-20px">Total Doctors</p>
                            {userData?.loader
                                ?
                                <CircularProgress size={20} className="theme-color-green" />
                                :
                                <p className="font-Poppins-SemiBold font-size-24px theme-color-green">
                                    {userData?.totalDoctors || "-"}
                                </p>
                            }
                        </div>
                    </div>
                    <div className="dashboard-sm-box">
                        <div className="dashboard-inner-box w-[80%] text-center">
                            <img className='admin-dashboard-img' src={iconRevenue} alt="biomarker-icon" />
                            <p className="font-Poppins-Medium whitespace-nowrap font-size-20px">Consultation <br /> Revenue</p>
                            {userData?.loader
                                ?
                                <CircularProgress size={20} className="theme-color-green" />
                                :
                                <p className="font-Poppins-SemiBold font-size-24px theme-color-green">
                                    {CURRENCY} {data?.consultationRevenue || "-"}
                                </p>
                            }
                        </div>
                    </div>
                    <div className="dashboard-sm-box">
                        <div className="dashboard-inner-box w-[80%] text-center">
                            <img className='admin-dashboard-img' src={iconRevenue} alt="biomarker-icon" />
                            <p className="font-Poppins-Medium whitespace-nowrap font-size-20px">Pending <br /> withdrawals</p>
                            {userData?.loader
                                ?
                                <CircularProgress size={20} className="theme-color-green" />
                                :
                                <p className="font-Poppins-SemiBold font-size-24px theme-color-green">
                                    {userData?.pendingWithdrawal || "-"}
                                </p>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="parent-box parent-box-graph-height">
                <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                    <div key={customerStates?.timePeriod}>
                        <h2 className="font-Poppins-SemiBold text-[#232323] font-size-20px mb-2">Customers</h2>
                        <div className='user-graph-inner'>
                            <div className='flex justify-between items-center'>
                                <div className='font-Poppins-Regular user-graph-header font-size-14px w-auto'>
                                    Total Customers: <span className='font-Poppins-SemiBold theme-color-green font-size-20px pl-1'>
                                        {customerStates?.timePeriod === "monthly" ? customerStates?.data?.monthlyTotal?.[0]?.totalMonthlyData || 0 : customerStates?.data?.yearlyTotal?.[0]?.totalYearlyData || 0}
                                    </span>
                                </div>
                                <div className='select-container-graph-user-manag'>
                                    {/* <div className='select-container-graph select-dropdown-container-graps w-auto'>
                                        <SelectDropdown
                                            options={cityList}
                                            isMulti={false}
                                            data={cityList?.filter(v => v.value === customerStates?.city)}
                                            setData={(e) => setCustomerStates(prev => ({ ...prev, city: e[0] ? e[0]?.value : "" }))}
                                            checkboxShow={false}
                                            isLabel={false}
                                        />
                                    </div> */}
                                    <div className='select-container-graph select-dropdown-container-graps w-auto'>
                                        <SelectDropdown
                                            options={timePeriodOptions}
                                            isMulti={false}
                                            data={timePeriodOptions?.filter(v => v.value === customerStates?.timePeriod)}
                                            setData={(e) => setCustomerStates(prev => ({ ...prev, timePeriod: e[0] ? e[0]?.value : "" }))}
                                            checkboxShow={false}
                                            isLabel={false}
                                            isRequired={true}
                                            clearIcon={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            {customerStates?.loader
                                &&
                                <div className="text-center">
                                    <CircularProgress size={20} style={{ color: "#004540" }} />
                                </div>
                            }
                            <ResponsiveContainer className={'user-graph-container'}>
                                <BarChart
                                    data={customerFormatedData()}
                                    margin={{ top: 20, right: 0, left: -35, bottom: 0 }}
                                    barCategoryGap="15%"
                                >
                                    <CartesianGrid />
                                    <XAxis className='revenue-axis' dataKey="name" />
                                    <YAxis className='revenue-axis' />
                                    <Tooltip wrapperClassName='revenue-axis' />
                                    <Bar dataKey="count" fill="#00443F" radius={[50, 50, 0, 0]} barSize={20} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    <div>
                        <h2 className="font-Poppins-SemiBold text-[#232323] font-size-20px mb-2">Doctors</h2>
                        <div className='user-graph-inner'>
                            <div className='flex justify-between items-center'>
                                <div className='font-Poppins-Regular user-graph-header font-size-14px w-auto'>
                                    Total Doctors: <span className='font-Poppins-SemiBold theme-color-green font-size-20px pl-1'>
                                        {doctorStates?.timePeriod === "monthly" ? doctorStates?.data?.monthlyTotal?.[0]?.totalMonthlyData || 0 : doctorStates?.data?.yearlyTotal?.[0]?.totalYearlyData || 0}
                                    </span>
                                </div>
                                <div className='select-container-graph-user-manag'>
                                    <div className='select-container-graph select-dropdown-container-graps w-auto'>
                                        <SelectDropdown
                                            options={cityList}
                                            isMulti={false}
                                            data={cityList?.filter(v => v.value === doctorStates?.city)}
                                            setData={(e) => setDoctorStates(prev => ({ ...prev, city: e[0] ? e[0]?.value : "" }))}
                                            checkboxShow={false}
                                            isLabel={false}
                                        />
                                    </div>
                                    <div className='select-container-graph select-dropdown-container-graps w-auto'>
                                        <SelectDropdown
                                            options={timePeriodOptions}
                                            isMulti={false}
                                            data={timePeriodOptions?.filter(v => v.value === doctorStates?.timePeriod)}
                                            setData={(e) => setDoctorStates(prev => ({ ...prev, timePeriod: e[0] ? e[0]?.value : "" }))}
                                            checkboxShow={false}
                                            isLabel={false}
                                            isRequired={true}
                                            clearIcon={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            {doctorStates?.loader
                                &&
                                <div className="text-center">
                                    <CircularProgress size={20} style={{ color: "#004540" }} />
                                </div>
                            }
                            <ResponsiveContainer className={'user-graph-container'}>
                                <BarChart
                                    data={doctorFormatedData()}
                                    margin={{ top: 20, right: 0, left: -35, bottom: 0 }}
                                    barCategoryGap="15%"
                                >
                                    <CartesianGrid />
                                    <XAxis className='revenue-axis' dataKey="name" />
                                    <YAxis className='revenue-axis' />
                                    <Tooltip wrapperClassName='revenue-axis' />
                                    <Bar dataKey="count" fill="#00443F" radius={[50, 50, 0, 0]} barSize={20} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserOverview;